var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPaintEye = function SvgPaintEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 37,
    height: 41,
    viewBox: "0 0 0.68 0.77",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.09;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2308851871264"
  }, /*#__PURE__*/React.createElement("path", {
    className: "str0",
    d: "M.35.72C-.2.17.16-.24.35.3.37.06.97-.2.35.72z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "str0",
    d: "M.63.37C.66.37.57.43.54.45.32.57.22.5.05.35.22.21.39.21.63.37z",
    fill: "#fff"
  })))));
};

export default SvgPaintEye;